import {ExcelUpload} from "../ExcelUpload";

export const ScheduleUpload = () => {
  return (
    <div className="p-8">
      <ExcelUpload
        title="Upload Match Schedule (Excel)"
        uploadUrl={`${process.env.REACT_APP_API_V2_URL}match-schedule/upload`}
      />
    </div>
  );
};


